import * as React from "react";
import { useTranslation } from "react-i18next";

import SearchIcon from "@mui/icons-material/Search";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import { BigSpinner } from "@/components/Spinner";
import ExtensionDetailsCard from "@/pages/browser-defender/extensionGovernance/ExtensionDetailsCard";
import ExtensionsTable from "@/pages/browser-defender/extensionGovernance/ExtensionsTable";
import BasicTabs from "@/pages/browser-defender/extensionGovernance/TabsComponent";

const LoadingContentSpinner = ({ loading, children }) => {
  if (loading) {
    return <BigSpinner />;
  }
  return children;
};

export default function DataPerCompany({
  content,
  onExtensionSelect,
  selectedExtension,
  loading,
  onAllowExtension,
  onBlockExtension,
  onSearchTermChange,
  updateSorting,
  sortingColumn,
  sortingDirection,
}) {
  const [currentTab, setCurrentTab] = React.useState(0);

  const { t } = useTranslation();

  const allowedExtensions = content.filter((ext) => !ext.blocked);
  const blockedExtensions = content.filter((ext) => ext.blocked);

  const handleTabChange = (newValue) => {
    setCurrentTab(newValue);
    onExtensionSelect(null);
  };

  return (
    <Box style={{ height: "100%", display: "flex" }}>
      <Grid container style={{ height: "100%", flex: 1 }}>
        <Grid
          item
          xs={5}
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <Card style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <CardContent
              style={{ flex: 1, display: "flex", flexDirection: "column" }}
            >
              <BasicTabs
                tabsLabels={[
                  t("Allowed.female_plural"),
                  t("Blocked.female_plural"),
                ]}
                tabsContent={[
                  <LoadingContentSpinner loading={loading} key="allowed">
                    <ExtensionsTable
                      values={allowedExtensions}
                      updateSorting={updateSorting}
                      sortingColumn={sortingColumn}
                      sortingDirection={sortingDirection}
                      setCurrentExtension={onExtensionSelect}
                      selectedExtension={selectedExtension}
                    />
                  </LoadingContentSpinner>,
                  <LoadingContentSpinner loading={loading} key="blocked">
                    <ExtensionsTable
                      values={blockedExtensions}
                      updateSorting={updateSorting}
                      sortingColumn={sortingColumn}
                      sortingDirection={sortingDirection}
                      setCurrentExtension={onExtensionSelect}
                      selectedExtension={selectedExtension}
                    />
                  </LoadingContentSpinner>,
                ]}
                searchComponent={
                  <TextField
                    InputProps={{
                      startAdornment: <SearchIcon />,
                    }}
                    size={"small"}
                    label={"Search"}
                    onKeyDown={onSearchTermChange}
                  />
                }
                value={currentTab}
                onChange={handleTabChange}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={7}
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          {selectedExtension ? (
            <ExtensionDetailsCard
              row={selectedExtension}
              currentTab={currentTab}
              onAllowExtension={onAllowExtension}
              onBlockExtension={onBlockExtension}
            />
          ) : (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography
                variant="h5"
                align="center"
                sx={{
                  color: (theme) => theme.palette.text.secondary,
                  maxWidth: "80%",
                }}
              >
                {t("Please select an extension to view the details")}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
